<template>
    <div class="btn-toolbar" role="toolbar">
        <slot />
    </div>
</template>

<script>
export default {

    name: 'BtnToolbar'

};
</script>
